export default {
  confirmUpdate: 'Save changes to this recipe?',
  recipeExists: 'Recipe exists',
  recipeName: 'Recipe name',
};
